import React from 'react';
import CSSModules from 'react-css-modules';
import { generateHash } from 'src/helpers/hashId';
import { buildUrl } from 'src/helpers/url';
import currencyMap from 'src/helpers/currencyMap';
import styles from './EmailShare.scss';
import { ShareActionOptions } from 'src/redux/modules/page';

interface Props {
  shareByEmail: (options: ShareActionOptions) => void;
  socialShareUrl: string;
  targetAmount: number;
  pitchFor: string;
  ownerName: string;
  isOwner: boolean;
  isActive: boolean;
  customStyle?: string;
  buttonText?: string;
  className?: string;
  location: string;
  shareHash?: string;
  eventValue?: string;
  subject?: string;
  body?: string;
  targetCurrency: Currency;
}

class EmailShare extends React.Component<Props> {
  getOwnerEmailBody(shareHash: string) {
    const {
      targetAmount,
      pitchFor,
      socialShareUrl,
      targetCurrency,
    } = this.props;

    const pageUrl = buildUrl(socialShareUrl, {
      utm_id: 2,
      utm_term: shareHash,
    });
    const homeUrl = buildUrl('https://home.justgiving.com/', {
      utm_id: 3,
      utm_term: shareHash,
    });

    const bodyTemplate = `Hello,
We're raising ${currencyMap[targetCurrency] ||
      '£'}${targetAmount} to ${pitchFor}.
Please donate to my JustGiving Crowdfunding Page and help make it happen:

${pageUrl}

Thanks for your support


PS. With JustGiving Crowdfunding anyone can raise money to fund their own project - anything from setting up a foodbank, to buying a wheelchair for a relative or even saving a local football club. Want to raise money to make good things happen? Start your Crowdfunding Page today.

${homeUrl}`;

    return bodyTemplate;
  }

  getOSupporterEmailBody(shareHash: string) {
    const { targetAmount, pitchFor, socialShareUrl, ownerName } = this.props;

    const pageUrl = buildUrl(socialShareUrl, {
      utm_id: 1,
      utm_term: shareHash,
    });
    const homeUrl = buildUrl('https://home.justgiving.com/', {
      utm_id: 3,
      utm_term: shareHash,
    });

    const bodyTemplate = `Hello,
Can you help ${ownerName} raise ${targetAmount} to ${pitchFor}?. Please donate to their JustGiving Crowdfunding Page:

${pageUrl}

Thanks for your support


PS. With JustGiving Crowdfunding anyone can raise money to fund their own project - anything from setting up a foodbank, to buying a wheelchair for a relative or even saving a local football club. Want to raise money to make good things happen? Start your Crowdfunding Page today.

${homeUrl}
`;

    return bodyTemplate;
  }

  handleEmailShare = () => {
    const {
      isOwner,
      pitchFor,
      ownerName,
      location,
      shareByEmail,
      shareHash,
      eventValue,
    } = this.props;

    const hash = shareHash || generateHash();

    const subject = this.props.subject
      ? this.props.subject
      : isOwner
        ? 'Please donate to my Crowdfunding Page'
        : `Donate to ${ownerName}'s Crowdfunding Page to ${pitchFor}`;

    const body = this.props.body
      ? this.props.body
      : isOwner
        ? this.getOwnerEmailBody(hash)
        : this.getOSupporterEmailBody(hash);

    shareByEmail({
      shareHash: hash,
      location,
      eventValue,
    });

    if (__CLIENT__) {
      window.location.href = `mailto:?subject=${encodeURIComponent(
        subject
      )}&body=${encodeURIComponent(body)}`;
    }
  };

  render() {
    const { isActive, customStyle, buttonText, className } = this.props;

    return (
      <button
        type="button"
        disabled={!isActive}
        className={className}
        styleName={customStyle}
        onClick={this.handleEmailShare}
      >
        {buttonText || 'Email'}
      </button>
    );
  }
}

export default CSSModules(EmailShare, styles);



// WEBPACK FOOTER //
// ./src/components/SocialShare/EmailShare.tsx